document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.hs-comp').forEach(section => {

    const tabs = section.querySelectorAll('.hs-comp__tab');
    const panels = section.querySelectorAll('.hs-comp__panel');

    if (!tabs.length || !panels.length) return;

    tabs.forEach(tab => {

      tab.addEventListener('click', () => {

        const target = tab.dataset.tab;

        tabs.forEach(button => {
          button.classList.remove('is-active');
          button.setAttribute('aria-selected', 'false');
        });

        panels.forEach(panel => {
          panel.classList.remove('is-active');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        const activePanel = section.querySelector(
          '.hs-comp__panel[data-panel="' + target + '"]'
        );

        if (activePanel) {
          activePanel.classList.add('is-active');
        }

      });

    });

  });

});